import { render } from "./ReviewsAndRatings.vue?vue&type=template&id=d7ba583a&scoped=true&lang=html"
import script from "./ReviewsAndRatings.vue?vue&type=script&lang=js"
export * from "./ReviewsAndRatings.vue?vue&type=script&lang=js"

import "./ReviewsAndRatings.vue?vue&type=style&index=0&id=d7ba583a&scoped=true&lang=scss"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7ba583a"]])

export default __exports__